<template>
  <div class="task-board" ref="taskBoard">
    <!--<div class="add-column" @click.stop="showNewColumnForm">
      <span class="add-column__icon">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 0L6 12" stroke="currentColor" stroke-width="2"/>
          <path d="M12 6L2.68221e-07 6" stroke="currentColor" stroke-width="2"/>
        </svg>
      </span>
      <span class="add-column__text">Создать новую колонку</span>
    </div>-->
    <div class="column-list">
      <Container orientation="horizontal"
                 non-drag-area-selector=".column-item_non-drag"
                 drag-class="column-item_drag"
                 @drag-start="onColumnPick"
                 @drop="onColumnDrop">
        <Draggable class="column-item" v-for="column in board.columns" :key="column.id">
          <TaskBoardColumn :column="column"
                           @toggle-column-controls="toggleColumnControls"
                           @show-task-info="openTaskDetail"
                           @update-column="updateColumn"
                           @remove-column="removeColumn"
                           @card-pick="onCardPick"
                           @card-drop="onCardDrop"
          />
        </Draggable>
        <transition name="fade">
          <Draggable class="column-item column-item_non-drag" v-if="board.createColumn.active">
            <div class="create-column" :class="columnColor" @click.stop>
              <div class="create-column__input">
                <AppInput borderless
                          placeholder="Название"
                          :value="board.createColumn.title"
                          :valid="{}"
                          width="220px"
                          @value-changed="setNewColumnTitle"
                          @keyup-enter="createNewColumn"
                />
              </div>
              <div class="create-column__color-picker">
                <AppColumnColorPicker :state="board.createColumn.colorPicker"
                                      @toggle-tooltip="toggleColorPicker"
                                      @set-color="setNewColumnColor"
                />
              </div>
              <div class="create-column__button" @click.stop="createNewColumn">
                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 6.35714L6.54658 11L14 1" stroke="currentColor" stroke-width="3"/>
                </svg>
              </div>
            </div>
          </Draggable>
        </transition>
      </Container>
    </div>
  </div>
</template>

<script>

import TaskBoardColumn from '@/components/task/TaskBoardColumn'
import AppInput from '@/components/page/input/AppInput'
import AppColumnColorPicker from '@/components/page/input/AppColumnColorPicker'
import { Container, Draggable } from 'vue-smooth-dnd'
export default {
  name: 'task-board',
  components: {
    AppColumnColorPicker,
    AppInput,
    TaskBoardColumn,
    Container,
    Draggable
  },
  props: {
    board: Object
  },
  data () {
    return {}
  },
  computed: {
    columnColor () {
      return {
        blue: this.board.createColumn.colorPicker.color === 'blue',
        orange: this.board.createColumn.colorPicker.color === 'orange',
        pink: this.board.createColumn.colorPicker.color === 'pink',
        green: this.board.createColumn.colorPicker.color === 'green',
        purple: this.board.createColumn.colorPicker.color === 'purple',
        violet: this.board.createColumn.colorPicker.color === 'violet'
      }
    }
  },
  methods: {
    showNewColumnForm () {
      this.$store.dispatch('showTaskBoardNewColumnForm')
      const elem = this.$refs.taskBoard

      /* плавная прокрутка вправо при добавлении новой колонки */
      setTimeout(() => {
        elem.scrollTo({
          left: elem.scrollWidth - elem.clientWidth,
          behavior: 'smooth'
        })
      }, 50)
    },
    toggleColorPicker () {
      this.$store.dispatch('toggleTaskBoardColorPicker')
    },
    setNewColumnColor (colorName) {
      this.$store.dispatch('setTaskBoardNewColumnColor', colorName)
    },
    setNewColumnTitle (title) {
      this.$store.dispatch('setTaskBoardNewColumnTitle', title)
    },
    createNewColumn () {
      this.$store.dispatch('taskBoardCreateNewColumn')
    },
    toggleColumnControls (columnId) {
      this.$store.dispatch('toggleTaskBoardColumnControls', columnId)
    },
    openTaskDetail (taskId) {
      this.$router.push({ path: `/task/info/${taskId}` })
    },
    updateColumn (itemId) {
      console.log('update board column', itemId)
    },
    removeColumn (itemId) {
      console.log('remove board column', itemId)
    },
    onColumnPick () {
      this.$store.dispatch('closeTaskBoardColumnControls')
      this.$store.dispatch('closeTaskBoardNewColumnForm')
    },
    onColumnDrop (dropResult) {
      this.$store.dispatch('setTaskBoardColumnNewPosition', dropResult)
    },
    onCardPick (data) {
      this.$store.dispatch('pickTaskBoardCard', data)
    },
    onCardDrop (data) {
      this.$store.dispatch('setTaskBoardCardNewPosition', data)
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.task-board {
  padding-bottom: 10px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: $color_third;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $color_second-light;
  }
}

.add-column {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  color: $color_second-light;
  cursor: pointer;
  user-select: none;
  transition: .3s;
  margin-bottom: 24px;

  &__icon {
    display: flex;
    align-items: center;
  }

  &__text {
    display: block;
    margin-left: 12px;
  }

  &:hover {
    color: $color_second;
  }
}

.column-item {
  padding-right: 18px;

  &_drag {
    cursor: grabbing;
  }

  &:last-child {
    padding-right: 20px;
  }
}

.column-list {
  display: flex;
  flex-flow: row nowrap;
}

.create-column {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 356px;
  padding: 8px;
  border-radius: 3px;
  cursor: auto;

  &__input {
    margin-right: 10px;
  }

  &__color-picker {
    margin-right: 10px;
    cursor: pointer;
  }

  &__button {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    color: $color_main;
    @include size(38px);
    border: 2px solid currentColor;
    border-radius: 3px;
    margin-left: auto;
    cursor: pointer;
    transition: .3s;

    &:hover {
      opacity: .5;
    }

    &.active {
      opacity: .5;
    }
  }

  &.blue {
    background: #2278BA;
    background: linear-gradient(90deg, #6672B1 0%, #2278BA 100%);
  }

  &.orange {
    background: #F86758;
    background: linear-gradient(95.94deg, #FAA658 -20.08%, #F86758 122.58%);
  }

  &.pink {
    background: #D75798;
    background: linear-gradient(102.64deg, #E8506F 9.26%, #D75798 100%);
  }

  &.green {
    background: #83BC70;
    background: linear-gradient(90deg, #559E97 -18.5%, #83BC70 119.25%);
  }

  &.purple {
    background: #790D7F;
    background: linear-gradient(90deg, #BC1183 -18.5%, #790D7F 119.25%);
  }

  &.violet {
    background: #143568;
    background: linear-gradient(90deg, #6E34B8 -18.5%, #143568 119.25%);
  }
}
</style>
